<template>
    <b-dropdown-item
        v-if="authorized"
        :to="to"
        :variant="color"
        @click="$emit('click', $event)"
    >
        <slot />
    </b-dropdown-item>
</template>

<script>
// Components.
import { BDropdownItem } from 'bootstrap-vue'

// Mixins.
import { permissao } from '@/mixins'

export default {
    components: { BDropdownItem },
    created() {
        this.authorized = this.verificarPermissao(this.authorize)
    },
    data: () => ({
        authorized: true
    }),
    mixins: [ permissao ],
    props: {
        authorize: { type: String, default: '' },
        color: { type: String },
        to: {type: [Object, String]},
    },
}
</script>